import { TTnaApprovalsActions } from './tna-approvals.actions';
import { TNA_APPROVALS_ITEMS_PER_PAGE_LIST } from './tna-approvals.facade';
import { TTnaApprovalsState, TTnaApprovalsActionType } from './tna-approvals.models';

export const initialState: TTnaApprovalsState = {
  tnaStepApprovalList: null,
  tnaStepApprovalDetails: null,
  tnaStepApprovalPendingList: null,
  tnaStepApprovalPendingDetails: null,
  userPaginationOption: {
    pageNo: 1,
    pageSize: TNA_APPROVALS_ITEMS_PER_PAGE_LIST[0],
  },
};

export function tnaApprovalsReducer(state = initialState, action: TTnaApprovalsActions): TTnaApprovalsState {
  switch (action.type) {
    case TTnaApprovalsActionType.GetTnaStepApprovalListSuccess:
      return {
        ...state,
        tnaStepApprovalList: {
          tnaStepApprovalList: action.tnaApprovalList,
          fetchReason: action.fetchReason,
        },
      };
    case TTnaApprovalsActionType.GetTnaStepApprovalDetailsSuccess:
      return {
        ...state,
        tnaStepApprovalDetails: {
          tnaStepApprovalDetails: action.tnaStepApproval,
          tosId: action.tosId,
        },
      };
    case TTnaApprovalsActionType.GetTnaStepApprovalPendingListSuccess:
      return {
        ...state,
        tnaStepApprovalPendingList: {
          tnaStepApprovalPendingList: action.tnaApprovalPendingList,
          fetchReason: action.fetchReason,
        },
      };
    case TTnaApprovalsActionType.GetTnaStepApprovalPendingDetailsSuccess:
      return {
        ...state,
        tnaStepApprovalPendingDetails: {
          tnaStepApprovalPendingDetails: action.tnaStepApprovalPending,
          approvalId: action.approvalId,
        },
      };
    case TTnaApprovalsActionType.SetUserPaginationOption:
      return {
        ...state,
        userPaginationOption: action.userPaginationOption,
      };
    default:
      return state;
  }
}
